import { ActionType, ProTable } from "@ant-design/pro-components";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef } from "react";
import UUIDComponent from "../../components/UUIDComponent";
import { Button, Form, message, Modal } from "antd";
import GlobalWrap from "../../components/globalWrap";
import AiInfoFrom from "./AiInfoFrom";
import { PlusOutlined } from "@ant-design/icons";

export default function AiInfo() {
    const { jsonRequest } = useGlobalState();
    const tableRef = useRef<ActionType>();
    const [form] = Form.useForm();

    useEffect(() => {
        tableRef.current?.reload();
    }, []);

    const columns: any[] = [
        {
            title: "序号",
            valueType: "index",
            search: false,
            align: "center",
        },
        {
            title: "ID",
            dataIndex: "id",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "名称",
            dataIndex: "name",
            align: "center",
            search: false,
        },
        {
            title: "备案号",
            dataIndex: "recordNumber",
            align: "center",
            search: false,
        },
        {
            title: "排序",
            dataIndex: "sort",
            align: "center",
            search: false,
        },
        {
            title: "审核状态",
            dataIndex: "status",
            align: "center",
            search: false,
            render: (text: string) => {
                switch (text) {
                    case "ENABLE":
                        return <span style={{ color: 'green' }}>启用</span>;
                    case "DISABLE":
                        return <span style={{ color: 'red' }}>禁用</span>;
                    default:
                        return <span>未知</span>;
                }
            }
        },
        {
            title: "创建时间",
            dataIndex: "createAt",
            align: "center",
            search: false,
        },
        {
            title: "操作",
            key: 'operation',
            search: false,
            align: "center",
            render: (_: any, record: any) => <>
                <Button type="link" onClick={() => handleAddOrEdit(record)}>编辑</Button>
            </>,
        }
    ];

    const handleAddOrEdit = (item: any) => {
        Modal.confirm({
            width: 500,
            title: !!item.id ? `编辑模型信息 - ${item.name}` : "新增模型信息",
            content: <GlobalWrap><AiInfoFrom form={form} item={item} /></GlobalWrap>,
            onOk: async (close) => {
                let values = await form.validateFields();
                if (!!item?.id) {
                    await jsonRequest.put("/back/model-public-notice/modify", {
                        ...values,
                        id: item.id,
                    }).then((resp: any) => resp.json())
                        .then((data: any) => {
                            if (data?.code === 0) {
                                message.success("编辑成功");
                            } else {
                                message.error(data?.msg || "编辑失败");
                            }
                        }
                        )
                } else {
                    await jsonRequest.post("/back/model-public-notice/add", {
                        ...values,
                    }).then((resp: any) => resp.json())
                        .then((data: any) => {
                            if (data?.code === 0) {
                                message.success("新增成功");
                            } else {
                                message.error(data?.msg || "新增失败");
                            }
                        }
                        )
                }
                tableRef.current?.reload();
                form.resetFields();
                close();
                return false;
            },
            onCancel: (close) => {
                form.resetFields();
                close();
            }
        })
    }

    const request = async (params: any) => {
        const result: any = await jsonRequest.get("/back/model-public-notice/page", {
            currentPage: params.current,
            pageSize: params.pageSize,
        }).then((resp: any) => resp.json());
        const { data } = result;
        return { data: data?.data, success: result.code === 0, total: data?.count };
    };

    return <>
        <h1>大模型信息公示管理</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 100 }}
            actionRef={tableRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false }}
            toolBarRender={() => [<>
                <Button
                    key="button"
                    icon={<PlusOutlined />}
                    onClick={() => handleAddOrEdit({})}
                    type="primary"
                >
                    新增
                </Button>
            </>]}
        />
    </>;
}